<form [formGroup]="patientForm">
  <dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
  >
  </dx-load-panel>
  <div id="requisitionForm" fxLayout="column" fxLayoutAlign="start center">
    <div
      class="content-block dx-card responsive-paddings ocl-top-container"
      style="width: 95vw; padding-bottom: 0 !important"
    >
      <dx-toolbar id="navigation-header" style="padding-right: 26px !important">
        <dxi-item location="before">
          <h3
            class="content-block"
            style="margin-top: 14px !important"
            *ngIf="patientId === -1"
          >
            New Patient
          </h3>
          <h3
            class="content-block"
            style="margin-top: 14px !important"
            *ngIf="patientId !== -1"
          >
            Edit Patient
          </h3>
        </dxi-item>
        <dxi-item location="after">
          <dx-button [text]="'Save Patient'" (click)="submit()"></dx-button>
        </dxi-item>
        <dxi-item location="after">
          <dx-button [text]="'Cancel'" (click)="goBack()"></dx-button>
        </dxi-item>
      </dx-toolbar>
    </div>
    <div
      class="content-block dx-card responsive-paddings ocl-bottom-container"
      style="width: 95vw"
    >
      <div fxLayout="row" fxLayout.lt-md="column" style="padding: 16px">
        <div
          fxLayout="column"
          fxFlex="45%"
          fxLayoutAlign="start space-between"
          style="padding-right: 30px"
          [ngStyle.lt-md]="{ 'padding-right': '0' }"
        >
          <div
            id="patientClient"
            fxLayout="column"
            fxLayoutAlign="start space-between"
          >
            <h4>Client Information</h4>
            <div fxLayout="row" fxFlex="50" fxFlex.xs="100">
              <app-client-selector
                [control]="patientForm.get('client')"
                [required]="true"
                [resultEntry]="true"
                [clearBtn]="false"
                [validationGroup]="'patient'"
              >
              </app-client-selector>
            </div>
            <div
              fxLayout="row"
              fxLayout.xs="column"
              fxLayoutAlign.xs="start"
              fxLayoutAlign="space-between"
            >
              <div fxFlex="28" fxFlex.xs="100">
                <app-selector
                  [items]="unitsDataSource.value"
                  [label]="'Unit'"
                  [remoteOperations]="true"
                  [control]="patientForm.get('unit')"
                  [displayExpr]="'name'"
                  [keyExpr]="'id'"
                  [required]="unitRequired"
                  [validationGroup]="'patient'"
                >
                </app-selector>
              </div>
              <div fxFlex="28" fxFlex.xs="100">
                <app-selector
                  [items]="selectRooms.value"
                  [label]="'Room'"
                  [remoteOperations]="true"
                  [control]="patientForm.get('room')"
                  [displayExpr]="'name'"
                  [keyExpr]="'id'"
                  [validationGroup]="'patient'"
                >
                </app-selector>
              </div>
              <div fxFlex="12" fxFlex.xs="100">
                <div class="dx-field">
                  <div class="dx-field-label">Bed</div>
                  <div class="dx-field-value">
                    <dx-text-box
                      class="uppercase"
                      [inputAttr]="{ autocomplete: 'new-bed' }"
                      formControlName="bed"
                    ></dx-text-box>
                  </div>
                </div>
              </div>
              <div fxFlex="28" fxFlex.xs="100">
                <div class="dx-field">
                  <div class="dx-field-label" style="width: 120px !important">
                    Medical Record Id
                  </div>
                  <div class="dx-field-value">
                    <dx-text-box
                      class="uppercase"
                      [inputAttr]="{ autocomplete: 'new-medicalrecordid' }"
                      formControlName="medicalRecordId"
                    ></dx-text-box>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            fxLayout="row"
            [ngStyle]="{ width: '50%' }"
            [ngStyle.xs]="{ width: '100%' }"
          >
            <app-physician-selector
              style="width: 100% !important"
              [label]="'Primary Physician'"
              [buttonMode]="false"
              [control]="patientForm.get('physician')"
              [required]="false"
              [validationGroup]="'patient'"
              [patientClientId]="PatientClient"
            ></app-physician-selector>
          </div>
          <div
            id="patientInfo"
            fxLayout="column"
            fxLayoutAlign="start space-between"
          >
            <h4>Patient Information</h4>
            <div
              fxLayout="row"
              fxLayout.xs="column"
              fxLayoutAlign.xs="start"
              fxLayoutAlign="space-between"
            >
              <div fxFlex="32" fxFlex.xs="100">
                <div class="dx-field">
                  <div class="dx-field-label">Last Name</div>
                  <div class="dx-field-value">
                    <dx-text-box
                      class="uppercase"
                      [inputAttr]="{ autocomplete: 'new-lastname' }"
                      formControlName="lastName"
                    >
                      <dx-validator validationGroup="patient">
                        <dxi-validation-rule
                          type="required"
                          message="Last Name is required"
                        ></dxi-validation-rule>
                      </dx-validator>
                    </dx-text-box>
                  </div>
                </div>
              </div>
              <div fxFlex="32" fxFlex.xs="100">
                <div class="dx-field">
                  <div class="dx-field-label">First Name</div>
                  <div class="dx-field-value">
                    <dx-text-box
                      class="uppercase"
                      [inputAttr]="{ autocomplete: 'new-firstname' }"
                      formControlName="firstName"
                    >
                      <dx-validator validationGroup="patient">
                        <dxi-validation-rule
                          type="required"
                          message="First Name is required"
                        ></dxi-validation-rule>
                      </dx-validator>
                    </dx-text-box>
                  </div>
                </div>
              </div>
              <div fxFlex="32" fxFlex.xs="100">
                <div class="dx-field">
                  <div class="dx-field-label">Middle Name</div>
                  <div class="dx-field-value">
                    <dx-text-box
                      class="uppercase"
                      [inputAttr]="{ autocomplete: 'new-middlename' }"
                      formControlName="middleName"
                    ></dx-text-box>
                  </div>
                </div>
              </div>
            </div>
            <div
              fxLayout="row"
              fxLayout.xs="column"
              fxLayoutAlign.xs="start"
              fxLayoutAlign="space-between"
            >
              <div fxFlex="32" fxFlex.xs="100">
                <div class="dx-field">
                  <div class="dx-field-label">Birth Date</div>
                  <div class="dx-field-value">
                    <dx-date-box
                      [inputAttr]="{ autocomplete: 'new-dob' }"
                      formControlName="dob"
                      [min]="firstDate"
                      type="date"
                      [max]="today"
                      (onContentReady)="onDateReady($event)"
                    >
                      <dx-validator validationGroup="patient">
                        <dxi-validation-rule
                          type="required"
                          message="Birth Date is required"
                        ></dxi-validation-rule>
                      </dx-validator>
                    </dx-date-box>
                  </div>
                </div>
              </div>
              <div fxFlex="32" fxFlex.xs="100">
                <div class="dx-field">
                  <div class="dx-field-label">Social Security Number</div>
                  <div class="dx-field-value">
                    <dx-text-box
                      [inputAttr]="{ autocomplete: 'new-ssn' }"
                      formControlName="ssn"
                      mask="000-00-0000"
                      [maskRules]="ssnMaskRule"
                    >
                      <dx-validator>
                        <p
                          *ngIf="patientForm.get('ssn')?.hasError('uniqueSSN')"
                        >
                          SSN already in use!
                        </p>
                        <dxi-validation-rule
                          type="async"
                          [validationCallback]="ssnHasError"
                          message="SSN is in use"
                        ></dxi-validation-rule>
                      </dx-validator>
                    </dx-text-box>
                  </div>
                </div>
              </div>
              <div fxFlex="32" fxFlex.xs="100">
                <div class="dx-field">
                  <div class="dx-field-label">Gender</div>
                  <div class="dx-field-value">
                    <dx-select-box
                      [dataSource]="gender"
                      placeholder="Select patient gender..."
                      formControlName="gender"
                    >
                      <dx-validator validationGroup="patient">
                        <dxi-validation-rule
                          type="required"
                          message="Gender is required"
                        ></dxi-validation-rule>
                      </dx-validator>
                    </dx-select-box>
                  </div>
                </div>
              </div>
            </div>
            <div
              fxLayout="row"
              fxLayout.xs="column"
              fxLayoutAlign.xs="start"
              fxLayoutAlign="space-between"
            >
              <div fxFlex="24" fxFlex.xs="100">
                <app-selector
                  [items]="sexualOrientationDataSource.value"
                  [label]="'Sexual Orientation'"
                  [remoteOperations]="true"
                  [control]="patientForm.get('sexualOrientation')"
                  [displayExpr]="'name'"
                  [keyExpr]="'id'"
                  [validationGroup]="'patient'"
                >
                </app-selector>
              </div>
              <div fxFlex="24" fxFlex.xs="100">
                <app-selector
                  [items]="genderIdentityDataSource.value"
                  [label]="'Gender Identity'"
                  [remoteOperations]="true"
                  [control]="patientForm.get('genderIdentity')"
                  [displayExpr]="'name'"
                  [keyExpr]="'id'"
                  [validationGroup]="'patient'"
                >
                </app-selector>
              </div>
              <div fxFlex="24" fxFlex.xs="100">
                <app-selector
                  [items]="raceDataSource.value"
                  [label]="'Race'"
                  [control]="patientForm.get('race')"
                  [validationGroup]="'patient'"
                >
                </app-selector>
              </div>
              <div fxFlex="24" fxFlex.xs="100">
                <app-selector
                  [items]="ethnicGroupsDataSource.value"
                  [label]="'Ethnic Group'"
                  [control]="patientForm.get('ethnicity')"
                  [displayExpr]="'name'"
                  [keyExpr]="'value'"
                  [validationGroup]="'patient'"
                >
                </app-selector>
              </div>
            </div>
          </div>
          <div [ngStyle.xs]="{ 'padding-top': '15px' }">
            <app-address
              [clientAddress]="patientForm.get('client')?.value?.address"
              [clientZipCode]="patientForm.get('client')?.value?.zipCode"
              [isSameAsClientControl]="
                convertToFormControl(patientForm.get('sameAsClient'))
              "
              [addressControl]="
                convertToFormControl(patientForm.get('address'))
              "
              [zipCodeControl]="
                convertToFormControl(patientForm.get('zipCode'))
              "
              [zipCodeExtraControl]="
                convertToFormControl(patientForm.get('zipCodeExtra'))
              "
              [loadInformation]="loadAddressInformation"
              [required]="true"
              [validationGroup]="'patient'"
            >
            </app-address>
          </div>
          <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign.xs="start"
            fxLayoutAlign="space-between"
          >
            <div fxFlex="32" fxFlex.xs="100">
              <div class="dx-field">
                <div class="dx-field-label">Phone</div>
                <div class="dx-field-value">
                  <dx-text-box
                    [inputAttr]="{ autocomplete: 'new-phone' }"
                    formControlName="phone"
                    mask="000-000-0000"
                    [maskRules]="phoneMaskRule"
                  ></dx-text-box>
                </div>
              </div>
            </div>
            <div fxFlex="32" fxFlex.xs="100">
              <div class="dx-field">
                <div class="dx-field-label">Mobile</div>
                <div class="dx-field-value">
                  <dx-text-box
                    [inputAttr]="{ autocomplete: 'new-mobile' }"
                    formControlName="mobile"
                    mask="000-000-0000"
                    [maskRules]="phoneMaskRule"
                  ></dx-text-box>
                </div>
              </div>
            </div>
            <div fxFlex="32" fxFlex.xs="100">
              <div class="dx-field">
                <div class="dx-field-label">Email</div>
                <div class="dx-field-value">
                  <dx-text-box
                    class="uppercase"
                    formControlName="email"
                    [inputAttr]="{ autocomplete: 'new-email' }"
                  >
                    <dx-validator>
                      <dxi-validation-rule
                        type="email"
                        message="Email is invalid"
                      >
                      </dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          fxLayout="column"
          fxFlex="55%"
          fxLayoutAlign="start space-between"
          style="padding-left: 30px"
          [ngStyle.lt-md]="{ 'padding-left': '0', 'padding-top': '15px' }"
        >
          <p fxHide fxShow.xs fxShow.sm>Slide tabs to see all options</p>
          <dx-tab-panel
            [dataSource]="[
              {
                id: 1,
                title: 'Insurance Information',
                template: 'billingInformationTabTemplate'
              },
              { id: 2, title: 'Diagnoses', template: 'diagnosesTabTemplate' },
              {
                id: 3,
                title: 'Medications',
                template: 'medicationsTabTemplate'
              },
              {
                id: 5,
                title: 'Responsible Party',
                template: 'responsiblePartiesTabTemplate'
              }
            ]"
            [height]="'655px'"
            [selectedIndex]="0"
            [loop]="false"
            [deferRendering]="true"
            style="max-height: 655px; padding-bottom: 16px"
            [animationEnabled]="true"
            [swipeEnabled]="true"
            (onSelectionChanged)="tabChanged()"
          >
            <div *dxTemplate="let company of 'billingInformationTabTemplate'">
              <div style="height: 100%">
                <app-billing-information
                  [patient]="patientForm.value"
                  [maxHeight]="600"
                  (patientBillingInfoChanged)="billingInfoChanged($event)"
                >
                </app-billing-information>
              </div>
            </div>
            <div *dxTemplate="let company of 'diagnosesTabTemplate'">
              <div style="height: 100%">
                <app-form-relation-glass
                  [maxHeight]="600"
                  [textSelectorPlaceholder]="'Code'"
                  [textSelectorExpr]="'code'"
                  [label]="'Diagnoses'"
                  [disabled]="isLoading"
                  [dataSource]="diagnosisDataSource.value"
                  [searchEnabled]="true"
                  [searchService]="diagnosisService"
                  [keyExpr]="'id'"
                  [columns]="diagnosticColumns"
                  [control]="convertToFormControl(patientForm.get('diagnoses'))"
                  (selectionChanged)="diagnoseChanged($event)"
                ></app-form-relation-glass>
              </div>
            </div>
            <div *dxTemplate="let company of 'medicationsTabTemplate'">
              <div style="height: 100%">
                <app-form-relation-glass
                  [maxHeight]="600"
                  [textSelectorPlaceholder]="'Code'"
                  [textSelectorExpr]="'code'"
                  [label]="'Medications'"
                  [disabled]="isLoading"
                  [dataSource]="medicationsDataSource.value"
                  [searchEnabled]="true"
                  [searchService]="medicationService"
                  [keyExpr]="'id'"
                  [columns]="['code', 'name']"
                  [control]="
                    convertToFormControl(patientForm.get('medications'))
                  "
                  (selectionChanged)="medicationChanged($event)"
                ></app-form-relation-glass>
              </div>
            </div>
            <div *dxTemplate="let company of 'responsiblePartiesTabTemplate'">
              <app-patient-responsible-parties
                [maxHeight]="600"
                [responsibleParties]="
                  patientForm.get('responsibleParties')?.value
                "
                (responsiblePartiesChanged)="responsiblePartiesChanged($event)"
              >
              </app-patient-responsible-parties>
            </div>
          </dx-tab-panel>
        </div>
      </div>
    </div>
  </div>
</form>
